import { useTranslation } from "react-i18next";

import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useSalonStore } from "@/lib/store/salon";

import { useReportsV2Store } from "../../store/use-reports-v2-store";

export function DiscountScopeToggle() {
  const { t } = useTranslation("reports");
  const discountScope = useReportsV2Store((s) => s.discountScope);
  const setDiscountScope = useReportsV2Store((s) => s.setDiscountScope);
  const currentFranchise = useSalonStore((s) => s.getCurrentFranchise());

  const canSeeFranchiseScope = currentFranchise?.franchise.salons.some(
    (s) => s.role === "OWNER" && s.isActive
  );

  if (!canSeeFranchiseScope) return null;

  return (
    <ToggleGroup
      type="single"
      value={discountScope}
      onValueChange={(v) => {
        if (v === "SALON" || v === "FRANCHISE") {
          setDiscountScope(v);
        }
      }}
      size="sm"
      variant="outline"
    >
      <ToggleGroupItem value="SALON">{t("discounts.scope.salon")}</ToggleGroupItem>
      <ToggleGroupItem value="FRANCHISE">{t("discounts.scope.franchise")}</ToggleGroupItem>
    </ToggleGroup>
  );
}
